import { useEffect, useState } from 'react'
import { useRender } from 'redity'
import useStorage from '../../hooks/useStorage'
import PageState from '../../types/pageState'
import { Keys } from './constant'
import loadMain from './utilities/loadMain'
import { storagePage } from './storage'
import useSession from '../../hooks/useSession'
import { get } from '../../lib/http'
import { CashboxUserData } from './types'

export default function useInitial() {
    const { isAdmin } = useSession()
    useRender(Keys.MAIN)
    const [pageState, setPageState] = useState(PageState.LOADING)
    const { cashboxes } = useStorage()

    useEffect(() => {
        const initializeData = async () => {
            try {
                storagePage.isAdmin = isAdmin()

                // Verificamos si el usuario tiene una caja abierta
                const result = await get<CashboxUserData | null>(
                    '/api/cashbox_users/get_open_cashbox_user'
                )

                if (result.error) {
                    setPageState(PageState.ERROR)
                    return
                }

                //Por defecto obtiene datos de la caja con id 1
                let cashboxId = 1

                if (result.data.result?.cashbox_id) {
                    // Si tiene una caja abierta, usamos su ID, sino usamos 1
                    cashboxId = result.data.result?.cashbox_id
                    storagePage.openedCashboxId = cashboxId
                }

                // Encontramos y seteamos la caja actual del usuario
                storagePage.currentCashbox =
                    cashboxes.find(cashbox => cashbox.id === cashboxId) || null

                // Llamamos a loadMain con el ID determinado
                const mainResult = await loadMain(cashboxId)
                setPageState(mainResult)
            } catch (error) {
                setPageState(PageState.ERROR)
            }
        }

        initializeData()
    }, [])

    return {
        pageState
    }
}
